import script from "./VNavigationLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./VNavigationLinks.vue?vue&type=script&setup=true&lang=ts"

import "./VNavigationLinks.vue?vue&type=style&index=0&id=43025d28&scoped=true&lang=css"

import exportComponent from "../../../../../../deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43025d28"]])

export default __exports__